module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/calendar-alt.svg?18f3ea8ffdf61a4f2f898895cb7622ee";